var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 70,
    viewBox: "0 0 100 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2658_2740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.39837 65.4404L0.629649 17.2785C0.462656 16.0902 0.776294 14.8841 1.50157 13.9254C2.22684 12.9667 3.30433 12.3339 4.49702 12.1663L86.5676 0.631997C87.7603 0.464376 88.9704 0.775638 89.9319 1.49731C90.8933 2.21898 91.5273 3.29195 91.6943 4.48017L98.463 52.6421C98.63 53.8304 98.3163 55.0365 97.5911 55.9952C96.8658 56.954 95.7883 57.5867 94.5956 57.7543L12.525 69.2886C11.3324 69.4562 10.1222 69.145 9.16075 68.4233C8.19931 67.7016 7.56537 66.6287 7.39837 65.4404V65.4404Z",
    fill: "#232F3E"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2658_2740)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1132 24.187C40.684 24.4048 39.7019 25.7398 39.9196 27.169L39.9277 27.2219C40.1498 28.6803 41.5122 29.6824 42.9706 29.4603L36.699 30.4156C35.7876 30.5545 35.1612 31.4059 35.3 32.3174L35.6017 34.2979C35.7406 35.2094 36.5921 35.8358 37.5035 35.6969L45.0954 34.5404L44.2909 29.2592L45.6112 29.058L46.4157 34.3393L51.697 33.5348L50.8925 28.2535L52.2128 28.0524L53.0173 33.3337L60.6092 32.1772C61.5207 32.0384 62.147 31.1869 62.0082 30.2754L61.7065 28.2949C61.5676 27.3834 60.7162 26.7571 59.8047 26.8959L53.5332 27.8513C54.9915 27.6291 55.9937 26.2668 55.7716 24.8084L55.7635 24.7555C55.5458 23.3263 54.2107 22.3442 52.7816 22.5619C52.1638 22.656 51.6001 22.968 51.1924 23.4414L48.0189 27.1261L43.8922 24.5535C43.3619 24.2229 42.7309 24.0929 42.1132 24.187ZM43.1856 25.6868L46.2662 27.6073L42.7695 28.14C42.0403 28.251 41.3591 27.75 41.248 27.0208L41.2399 26.9679C41.1333 26.2679 41.6143 25.614 42.3143 25.5074C42.6169 25.4613 42.9259 25.5249 43.1856 25.6868ZM52.2043 24.313L49.8353 27.0636L53.332 26.531C54.0612 26.4199 54.5623 25.7387 54.4512 25.0095L54.4432 24.9566C54.3365 24.2566 53.6827 23.7756 52.9827 23.8822C52.6801 23.9283 52.404 24.0811 52.2043 24.313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0348 36.967L45.2965 35.8608L47.1067 47.7437L41.8254 48.5482C40.367 48.7703 39.0046 47.7682 38.7825 46.3098L37.4752 37.7277C37.4196 37.3631 37.6702 37.0225 38.0348 36.967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6168 35.6596L48.427 47.5425L53.7083 46.738L51.8981 34.8551L46.6168 35.6596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5483 42.6895C62.7704 44.1479 61.7683 45.5103 60.3099 45.7324L55.0286 46.5369L53.2185 34.654L60.4802 33.5478C60.8448 33.4923 61.1854 33.7428 61.241 34.1074L62.5483 42.6895Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2658_2740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91.9596,
    height: 57.6837,
    fill: "white",
    transform: "translate(0 12.7983) rotate(-8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2658_2740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.0533,
    height: 32.0533,
    fill: "white",
    transform: "translate(31 21.827) rotate(-8.66132)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.a85649f4e1e1fd2e02aaac73843ff554.svg";
export { ForwardRef as ReactComponent };